export const baseActionTypes = {
    setLoading: "setLoading",
    setLang: "setLang"
};
